module.exports = __webpack_public_path__ + "static/media/news-attachment-1.6d26ba6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-attachment-1.png
// module id = 525
// module chunks = 0